import { render } from "./WorkingSiteAssignedUsers.vue?vue&type=template&id=a52eb9ce&scoped=true&ts=true&lang=pug"
import script from "./WorkingSiteAssignedUsers.vue?vue&type=script&lang=ts"
export * from "./WorkingSiteAssignedUsers.vue?vue&type=script&lang=ts"

import "./WorkingSiteAssignedUsers.vue?vue&type=style&index=0&id=a52eb9ce&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52eb9ce"]])

export default __exports__